var _path, _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#432a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "433b",
    width: 22,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#433b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005CB2",
    fillRule: "evenodd",
    d: "M10.476 3.2H22v2.133H10.476zm0 4.266H22v2.133H10.476zM0 11.733h22v2.133H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEA7B",
    fillRule: "evenodd",
    d: "M7.208 7.338C6.967 8.666 6.41 9.6 5.762 9.6c-.65 0-1.205-.932-1.446-2.26-1.304-.246-2.22-.812-2.22-1.473s.915-1.227 2.22-1.472c.241-1.328.796-2.261 1.446-2.261s1.205.932 1.446 2.261c1.304.245 2.22.81 2.22 1.472s-.915 1.227-2.22 1.472",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCD715",
    fillRule: "evenodd",
    d: "M6.482 6.599c-.067 1.71-.364 3-.72 3s-.653-1.29-.72-3c-1.68-.068-2.947-.37-2.947-.733s1.268-.664 2.947-.733c.067-1.71.364-3 .72-3s.653 1.29.72 3c1.679.069 2.947.37 2.947.733s-1.268.665-2.947.733",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCD715",
    d: "M5.762 7.466c.868 0 1.571-.717 1.571-1.6s-.703-1.6-1.571-1.6-1.572.716-1.572 1.6c0 .883.704 1.6 1.572 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19.905.535H2.095c-.868 0-1.571.717-1.571 1.6V13.87c0 .883.703 1.6 1.571 1.6h17.81c.868 0 1.571-.717 1.571-1.6V2.134c0-.883-.703-1.6-1.571-1.6Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "432a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v16H0z"
  })))));
});
const SvgFlagUy = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagUy);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,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";